import { Typography, Space } from 'antd'
import CIMSLink from 'components/CIMSLink'
import { SharePointResource } from 'schema'

const SharePointExternalLink: React.FC<
  Partial<Pick<SharePointResource, 'webUrl'>>
> = ({ webUrl }) => {
  return (
    <CIMSLink
      external
      href={webUrl}
      tooltip={
        !webUrl
          ? {
              title: `There is no SharePoint Folder in the database for this record!`,
              content: (
                <Space
                  size="small"
                  direction="vertical"
                  style={{ maxWidth: 300 }}
                >
                  <Typography.Text>
                    For whatever reason, a SharePoint Folder in the Document
                    Library was not attached to this record.
                  </Typography.Text>
                  <Typography.Text>
                    You can attempt to link a folder by using the Link Folder
                    action.
                  </Typography.Text>
                </Space>
              ),
            }
          : undefined
      }
    >
      SharePoint Folder
    </CIMSLink>
  )
}

export default SharePointExternalLink
